import clsx from 'clsx';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';

import { Modal } from '../Modal/Modal';

import { IntroStep } from './_components/IntroStep';
import { SuccessStep } from './_components/SuccessStep';
import { VideoStep } from './_components/VideoStep';
import styles from './QuickStart.module.scss';

interface QuickStartProps {
  showModal: boolean;
  onClose: () => void;
  initialStep?: number;
}

export const QuickStart: React.FC<QuickStartProps> = ({ showModal, onClose, initialStep = 0 }) => {
  const { events } = useRouter();
  const [step, setStep] = useState(initialStep);
  const [done, setDone] = useState(false);
  const [intro, setIntro] = useState(initialStep === 0);

  useEffect(() => {
    setStep(initialStep);
    setDone(false);
    setIntro(initialStep === 0);
  }, [initialStep]);

  const onCloseHandle = useCallback(() => {
    onClose();
    setStep(0);
    setDone(false);
    setIntro(true);
  }, [onClose]);

  useEffect(() => {
    events.on('routeChangeComplete', onCloseHandle);
    return () => events.off('routeChangeComplete', onCloseHandle);
  }, [events, onCloseHandle]);

  const isSpecialView = intro || done;

  return (
    <Modal
      className={clsx(styles.modal, { [styles.modalSpecial]: isSpecialView })}
      view="info"
      onClose={onCloseHandle}
      showModal={showModal}
    >
      {intro && <IntroStep onStart={() => setIntro(false)} />}

      {done && <SuccessStep onClose={onCloseHandle} />}

      {!intro && !done && (
        <VideoStep
          step={step}
          onStepSelect={setStep}
          onPrev={() => setStep(s => s - 1)}
          onNext={() => setStep(s => s + 1)}
          onFinish={() => setDone(true)}
        />
      )}
    </Modal>
  );
};
